export const SET_FORM_FIELD_ERROR = 'SET_FORM_ERROR';
export const REMOVE_FORM_FIELD_ERROR = 'REMOVE_FORM_FIELD_ERROR';
export const RESET_FORM_FIELD_ERROR = 'RESET_FORM_FIELD_ERROR';
